import { render, staticRenderFns } from "./ManageCompanyReports.vue?vue&type=template&id=6b51174c"
import script from "./ManageCompanyReports.vue?vue&type=script&lang=js"
export * from "./ManageCompanyReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports